import React, { useState, useEffect } from "react";
import API from '../api/index';

function ExpertItem(skill,index){
	return(
		<div class="col-md-6" key={index}>
			<div class="expertise-item">
				<h3>{skill}</h3>
			</div>
		</div>
	)
}

function Expertise() {
	const [expertiseData, setExpertiseData] = useState([]);
	let count = 1;

	useEffect(() => {
		let expertiseData = API.getExpertise();
		expertiseData.then(
			response => {
				setExpertiseData(response.records)
			}
		);
	}, [count]);

	return(
		<section class="expertise-wrapper section-wrapper gray-bg">
			<div class="container-fluid">
				<div class="row">
					<div class="col-md-12">
						<div class="section-title">
							<h2>Expertise</h2>
						</div>
					</div>
				</div>

				<div class="row">
					{
						expertiseData	?	
							expertiseData.map((item,index) => 
								ExpertItem(item.fields.Skill, index)
							)
						:	<></>
					}
				</div>
			</div>
		</section>
	)
}

export default Expertise;